import { Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";

interface BackLinkProps {
  to: string;
  label?: string;
}

export default function BackLink({ to, label = "Home" }: BackLinkProps) {
  return (
    <Link
      to={to}
      className="inline-flex items-center gap-1 text-sm text-gray-500 hover:text-gray-700 mb-4"
    >
      <ChevronLeft className="w-4 h-4" />
      {label}
    </Link>
  );
}
